import DeletePositionTypeGroup from "./DeletePositionTypeGroup";
export default DeletePositionTypeGroup;
